import { render, staticRenderFns } from "./robotArmSetting.vue?vue&type=template&id=286561ee&scoped=true&"
import script from "./robotArmSetting.vue?vue&type=script&lang=js&"
export * from "./robotArmSetting.vue?vue&type=script&lang=js&"
import style0 from "./robotArmSetting.vue?vue&type=style&index=0&id=286561ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286561ee",
  null
  
)

export default component.exports